import React, { useCallback } from 'react'
import Modal from '@/components/Modal'
import ReactQRCode from 'react-qr-code'
import Text from '@/components/Text'
import { QRCard, CardTopAction } from './components'
import CloseIcon from '@mui/icons-material/Close'
import { checkVerification } from '@/api'
import { useQuery } from '@tanstack/react-query'

export interface QRCodeProps {
  url: string | undefined;
  onClose: () => void;
  onFinish: () => void;
}

export const QRCode: React.FC<QRCodeProps> = (props) => {
  const { url, onClose, onFinish } = props

  useQuery(['checkVerification'], checkVerification, {
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    enabled: !!url,
    refetchInterval: 3000,
    onSuccess: (res) => {
      if (res?.certify_status === 1) {
        onFinish()
      }
    },
  })

  const close = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <Modal open={!!url} onClose={onClose}>
      <QRCard>
        <CardTopAction>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={close} />
        </CardTopAction>
        <Text>请打开支付宝扫码</Text>
        <Text weight='thin' size='xs'>
          若失败，请确认信息无误后重新认证
        </Text>
        <QRCard
          sx={{
            boxShadow: 'none',
            backgroundImage: 'none',
            background: 'transparent',
          }}
        >
          {/*   @ts-ignore */}
          <ReactQRCode value={url} />
        </QRCard>
      </QRCard>
    </Modal>
  )
}

export default QRCode
